module.exports = __webpack_public_path__ + "static/media/intro.dc5289b2.mp3";